<template>
  <div>
    <b-modal
      footer="{null}"
      centered
      id="sim_swap_popup"
      title="Changer ma SIM"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      class="position-relative"
    >
      <div class="position-relative">
        <div v-if="current_step == 1">
          <div class="modal-header-wrap text-center">
            <i
              class="
                kgk-mtn-BW_Icons_MTNMoMo_GlobalConnect_4
                modal-header-icon
                yellow-muted
              "
            ></i>
            <h3>Changement de SIM</h3>
            <p v-if="current_step == 1" class="text-muted">
              <span
                >Vous avez perdu votre SIM et vous souhaitez le récupérer
                ?</span
              ><br />
              Vous pouvez le faire ici sans vous déplacer<br />
              Vous avez juste besoin d'avoir une photo de votre pièce d'identité
              et une carte sim vierge. Si vous n'avez pas de carte SIM vierge,
              <a
                target="_blanj"
                href="https://www.mtn.bj/boutique/produit/sim-change-vierge/"
                >cliquez ici</a
              >
            </p>
          </div>
          <div></div>
          <div class="mt-3 mb-3 text-center">
            <button @click="next()" class="btn btn-primary">
              <b-spinner small v-if="is_loading" label="Loading..."></b-spinner>
              <span v-if="!is_loading" class="d-flex align-items-center">
                Faire la demande
                <i class="ml-1 mdi mdi-arrow-right"></i>
              </span>
            </button>
          </div>
        </div>
        <div class="" v-if="current_step == 2">
          <ValidationObserver v-slot="{ handleSubmit }">
            <b-form
              @submit.prevent="handleSubmit(sendRequest)"
              class="position-relative"
            >
              <div>
                <b-form-group
                  id="input-group-1"
                  label="Numéro de la SIM Vierge"
                  label-for="input-1"
                  description="Numéro à 11 chiffres se trouvant derrière la SIM vierge"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    rules="required|length:11"
                  >
                    <b-form-input
                      id="input-1"
                      v-model="form.sim_vierge"
                      placeholder="Entrer le numéro de la SIM vierge"
                    ></b-form-input>
                    <VFieldErrors :errors="errors" class="w-100" />
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  id="input-group-2"
                  label="Quel type de pièce souhaitez ajouter?"
                  label-for="input-2"
                >
                  <validation-provider v-slot="{ errors }" rules="required">
                    <select
                      class="form-select"
                      aria-label="Default select example"
                      v-model="form.type"
                    >
                      <option selected value="">
                        -- Sélectionner le type de ma pièce --
                      </option>
                      <option
                        v-for="(type, index) in types_pieces"
                        :key="index"
                        :value="type.value"
                      >
                        {{ type.text }}
                      </option>
                    </select>
                    <VFieldErrors :errors="errors" class="w-100" />
                  </validation-provider>
                </b-form-group>

                <b-form-group label="Date d'expiration">
                  <div class="d-flex justify-content-between">
                    <div class="mb-1 mr-2 w-100">
                      <validation-provider v-slot="{ errors }" rules="required">
                        <select
                          class="form-select"
                          aria-label="Default select example"
                          v-model="form.day"
                        >
                          <option selected value="">Jours</option>
                          <option v-for="(d, i) in days" :key="i" :value="d">
                            {{ d }}
                          </option>
                        </select>
                        <VFieldErrors :errors="errors" class="w-100" />
                      </validation-provider>
                    </div>
                    <div class="mb-1 mr-2 w-100">
                      <validation-provider v-slot="{ errors }" rules="required">
                        <select
                          class="form-select"
                          aria-label="Default select example"
                          v-model="form.month"
                        >
                          <option selected value="">Mois</option>
                          <option v-for="(m, i) in months" :key="i" :value="m">
                            {{ m }}
                          </option>
                        </select>
                        <VFieldErrors :errors="errors" class="w-100" />
                      </validation-provider>
                    </div>
                    <div class="mb-1 w-100">
                      <validation-provider v-slot="{ errors }" rules="required">
                        <select
                          class="form-select"
                          aria-label="Default select example"
                          v-model="form.year"
                        >
                          <option selected value="">Année</option>
                          <option v-for="(y, i) in years" :key="i" :value="y">
                            {{ y }}
                          </option>
                        </select>
                        <VFieldErrors :errors="errors" class="w-100" />
                      </validation-provider>
                    </div>
                  </div>
                  <div class="alert alert-warning mt-2">
                    Assurez-vous d’attacher une pièce d’identité valide. Seules
                    les pièces valides sont acceptées.
                  </div>
                </b-form-group>
                <b-form-group
                  label="Attacher une photo à la pièce"
                  description="Extensions acceptées: .png, .jpeg, .jpg"
                >
                  <input
                    class="form-control"
                    type="file"
                    id="formFile"
                    accept=".png, .jpg, .jpeg"
                    @change="process_file($event)"
                  />
                  <VFieldErrors
                    :errors="error_file"
                    class="w-100"
                    v-if="file_datauri == 'init' && error_file !== ''"
                  />
                </b-form-group>
              </div>

              <div
                class="mt-3 mb-3 text-right modal-footer"
                :style="
                  show_global_alert == true ? 'margin-top: 60px !important' : ''
                "
              >
                <div
                  v-if="show_global_alert == true"
                  class="modal-globa-notification"
                >
                  {{ show_global_alert_content }}
                </div>
                <div class="d-flex align-items-center justify-content-center">
                  <button
                    type="submit"
                    @click="check_value()"
                    class="btn btn-primary"
                  >
                    <b-spinner
                      small
                      v-if="is_loading"
                      label="Loading..."
                    ></b-spinner>
                    <span v-if="!is_loading" class="d-flex align-items-center">
                      Continuer
                    </span>
                  </button>
                </div>
              </div>
            </b-form>
          </ValidationObserver>
        </div>
        <div v-if="current_step == 3" class="text-center step-three py-3">
          <i class="mdi mdi-check"></i>
          <p class="pb-0">
            Un ticket vient d’être créé pour votre demande de changement SIM.
            Vous pouvez suivre le traitement avec le numéro ci dessous.
          </p>
          <div
            class="alert alert-warning mt-2"
            v-html="message"
            v-if="message.trim() !== ''"
          ></div>
          <div
            class="
              d-flex
              justify-content-center
              align-items-center
              text-center
              flex-wrap
            "
          >
            <h3 id="copy-text" class="mb-0">
              {{ ticket_id }}
            </h3>
            <div class="copy ms-2">
              <span class="mdi mdi-content-copy" @click="copyText()">
                Copier
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-center mt-3">
            <a class="btn btn-primary" target="_blank" :href="ticket_url">
              <span class="d-flex align-items-center">
                <span class="fw-500"> Suivez votre demande</span>
                <i class="mdi mdi-arrow-right ms-2"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
      <div></div>
    </b-modal>
  </div>
</template>

<script>
import VFieldErrors from "@/components/utils/VFieldsErrors";
import { subscriber } from "@/services/";
import { required, length, phone } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
import compress from "compress.js";
extend("required", {
  ...required,
  message: "Champ obligatoire",
});
extend("length", {
  ...length,
  message: "Le numéro doit contenir 11 chiffres",
});
extend("phone", (value) => {
  let authorized_max_lengths = store.state.settings?.phone_prefixes?.msisdn_length ?? [10];
  const prefixes = store.state.settings?.phone_prefixes?.mtn ?? [];

  let prefixIncluded = prefixes.some((pr) => value.toString().startsWith(pr));
  const lengthOf = value.toString().length;
  return prefixIncluded && authorized_max_lengths.includes(lengthOf);
});
extend("phone", {
  ...phone,
  name: "name",
  message: "Le numéro de téléphone est invalide",
});
export default {
  name: "SimCardSWAP",
  components: {
    VFieldErrors,
  },
  data: () => {
    return {
      is_ok: false,
      is_loading: false,
      current_step: 1,
      ticket_url: "#",
      days: [],
      months: [],
      years: [],
      ticket_id: "",
      form: {
        sim_vierge: "",
        notif_phone: "",
        type: "",
        name: "",
        email: "",
        type_piece: "",
        day: "",
        month: "",
        year: "",
        file_url: "",
      },

      show_global_alert: false,
      show_global_alert_to: "",
      show_global_alert_content: "",
      types_pieces: [
        {
          text: "Carte Nationale d'identité",
          value: "CARTE_NATIONAL_IDENTITE",
        },
        { text: "Carte Nationale Biométrique", value: "CN_BIOMETRIQUE" },
        {
          text: "Certificat d'identification personnelle",
          value: "CERTIFICAT_IDENTIFICATION_PERSONNEL",
        },
        { text: "Passeport", value: "PASSPORT" },
        { text: "Carte Lépi", value: "LEPI" },
      ],
      piece: "",
      file_datauri: "init",
      error_file: "",
      message: "",
    };
  },
  mounted() {
    const now = new Date();
    let now_year = now.getUTCFullYear();
    const actualy_day_number = now.getUTCDate();
    const actualy_month_number = now.getUTCMonth();
    for (let i = 1; i <= 31; i++) {
      if (i < 10) {
        i = "0" + i;
      }
      this.days.push(i);
    }
    for (let i = 1 + 1; i <= 12; i++) {
      if (i < 10) {
        i = "0" + i;
      }
      this.months.push(i);
    }
    for (let i = 0; i < 11; i++) {
      this.years.push(now_year++);
    }
  },
  computed: {
    isNotMobileScreen() {
      if (window.screen.availWidth >= 600) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    next: function () {
      this.current_step++;
    },
    isValidPhone(value) {
      let authorized_max_lengths = this.$store.state.settings?.phone_prefixes?.msisdn_length ?? [10];
      const prefixes = this.$store.state.settings?.phone_prefixes?.mtn ?? [];

      let prefixIncluded = prefixes.some((pr) => value.toString().startsWith(pr));
      const lengthOf = value.toString().length;
      return prefixIncluded && authorized_max_lengths.includes(lengthOf);
    },
    copyText() {
      var $temp = $("<input>");
      $("body").append($temp);
      $temp.val($("#copy-text").text()).select();
      document.execCommand("copy");
      $temp.remove();
    },
    checkValidation() {
      if (
        this.form.sim_vierge.toString().length == 11 &&
        this.form.type !== "" &&
        this.file_datauri !== "init" &&
        this.file_datauri !== "" &&
        this.form.day !== "" &&
        this.form.month !== "" &&
        this.form.year !== ""
      ) {
        return true;
      } else {
        this.show_global_alert = true;
        this.show_global_alert_content = "Erreur au niveau de certains champs";
      }
    },
    check_value() {
      if (this.file_datauri === "init") {
        this.error_file = ["Veuillez choisir la photo de la pièce"];
      }
      this.checkValidation();
    },
    async sendRequest() {
      if (this.is_loading == true) {
        return;
      } else {
        if (this.file_datauri === "init") {
          this.error_file = ["Veuillez choisir la photo de la pièce"];
          return;
        } else if (this.file_datauri !== "" && this.file_datauri !== "init") {
          this.is_loading = true;
          const response = await this.uploadFile();
          if (response && !_.isUndefined(response.file_url)) {
            this.form.file_url = response.file_url;
            let datas = {
              card_date:
                this.form.day + "-" + this.form.month + "-" + this.form.year,
              card_type: this.form.type,
              card_url: this.form.file_url,
              b_number: this.form.sim_vierge,
            };
            await subscriber.functionsimSwap(datas).then((response) => {
              if (response.ticket_id) {
                this.ticket_id = response.ticket_id;
                this.ticket_url = response.ticket_url;
                this.message = response.message;
                this.is_loading = false;
                this.next();
              }
            });
          } else if (
            !_.isUndefined(response.error) ||
            !_.isUndefined(response.internal_error)
          ) {
            this.is_loading = false;
            this.utils_show_global_alert({
              text: response.error,
              type: "danger",
            });
          }
          this.is_loading = false;
        }
      }
    },
    async process_file(event) {
      this.file_datauri = "";
      this.piece = event.target.files[0];
      if (this.piece) {
        const fileSize = this.piece.size / 1024 / 1024; // in MiB
        if (fileSize > 30) {
          this.file_datauri = "init";
          this.error_file = ["Le fichier ne peut excéder 30Mo"];
        } else {
          this.file_datauri = await this.compress_file(event);
          this.error_file = "";
        }
      } else {
        this.file_datauri = "init";
        this.error_file = ["Veuillez choisir la photo de la pièce"];
      }
    },
    async compress_file(event) {
      this.piece = "";
      var self = this;
      this.piece = "";
      var self = this;
      const browserSupportsExifOrientation = () => {
        return new Promise((resolve) =>
          Modernizr.on("exiforientation", resolve)
        );
      };
      const shouldRotate = async () => {
        const supported = await browserSupportsExifOrientation();
        return !supported;
      };
      const rotate = await shouldRotate();
      const files = [...event.target.files];
      const results = await new compress().compress(files, {
        size: 4,
        quality: 0.65,
        rotate,
      });
      const output = results[0];
      const file = await compress.convertBase64ToFile(output.data, output.ext);
      this.piece = output.prefix + output.data;
      return output.prefix + output.data;
    },
    dataURItoBlob: function (dataURI) {
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0)
        byteString = atob(dataURI.split(",")[1]);
      else byteString = unescape(dataURI.split(",")[1]);
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], {
        type: mimeString,
      });
    },
    async uploadFile() {
      var formData = new FormData();
      var blob = this.dataURItoBlob(this.file_datauri);
      var extension = blob.type.split("/");
      formData.append("upload_file", blob, "piece." + extension[1]);
      formData.append("path", "sim-swap");
      return jQuery.ajax({
        url: "https://chat.mtn.bj/upload/",
        data: formData,
        type: "POST",
        mimeType: "multipart/form-data",
        contentType: false,
        dataType: "json",
        cache: false,
        processData: false,
      });
    },
  },
  computed: {},
  watch: {
    show_global_alert: function (new_val) {
      var self = this;
      if (new_val) {
        setTimeout(function () {
          self.show_global_alert_to = self.show_global_alert = false;
        }, 5000);
      }
    },
  },
};
</script>
<style scoped lang="css">
#puk_details {
  font-weight: bold;
  font-size: 22px;
  letter-spacing: 2px;
}
::v-deep .modal-body {
  overflow-y: auto !important;
  position: relative !important;
}
::v-deep label {
  font-size: 12px !important;
  margin-bottom: 3px !important;
  font-weight: 400 !important;
  font-weight: 700 !important;
}
::v-deep .form-text {
  font-size: 10px !important;
  color: #6c757d !important;
  font-weight: 400 !important;
}
::v-deep ::placeholder {
  color: #6c757d !important;
}
::v-deep .alert-warning {
  font-size: 12px !important;
  font-weight: 400 !important;
  padding: 8px !important;
}
::v-deep select:focus,
input:focus {
  border: 1px solid #ced4da !important;
}
/* Chrome, Safari, Edge, Opera */
::v-deep input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0 !important;
}

/* Firefox */
::v-deep input[type="number"] {
  -moz-appearance: textfield !important;
}
::v-deep .modal-body {
  max-height: 540px !important;
  padding-bottom: 0;
}

.modal-footer {
  box-shadow: 0 0px 0px rgb(0 0 0 / 10%) !important;
  background: #ffffff !important;
  position: sticky;
  bottom: 0;
  margin-bottom: 0 !important;
}

.copy {
  background: #e4e5e6;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 4px;
  cursor: pointer;
}
.step-three p {
  padding: 15px 30px 30px 30px;
}
.mdi-check {
  background: rgb(49, 167, 5);
  color: #fff !important;
  display: inline-block;
  width: 60px;
  height: 60px;
  line-height: 60px;
  border-radius: 50%;
  font-size: 32px;
  margin: 30px 0 0 0;
}
.mdi-arrow-right {
  font-size: 20px !important;
  vertical-align: middle !important;
}
.fw-500 {
  font-weight: 500 !important;
}
.modal-globa-notification {
  background: #d81822;
  position: absolute;
  bottom: 63px;
  width: calc(100% + 32px);
  margin-top: 32px !important;
  left: -20px;
  color: #fff;
  text-align: center;
  padding: 10px;
  z-index: 100;
  font-size: 13px !important;
}
</style>